import { ChakraFlex as Flex, ChakraHeading as Heading } from "@airhelp/react-ui-components";
import type { CircularProgressProps } from "./CircularProgress.d";
import { Circle0, Circle35, Circle50, Circle65, Circle100 } from "./ProgressCircles";

const progressCircle = {
  0: <Circle0 />,
  35: <Circle35 />,
  50: <Circle50 />,
  65: <Circle65 />,
  100: <Circle100 />,
};

const CircularProgress = ({ progressValue }: CircularProgressProps) => {
  if (!progressCircle[progressValue]) {
    return null;
  }

  return (
    <Flex width="200px" align="center" justify="center">
      {progressCircle[progressValue]}
      <Heading variant="h3" as="h3" textAlign="left" position="absolute">
        {progressValue}%
      </Heading>
    </Flex>
  );
};

export default CircularProgress;
